import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './Services.css';
import BookingForm from './BookingForm';

const Services = () => {
   const [showBookingForm, setShowBookingForm] = useState(false);
  const [serviceName, setServiceName] = useState("")
   const handleBookNow = (title) => {
    setServiceName(title);
    setShowBookingForm(true);
    
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
     const buttons = document.querySelectorAll('.service-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--white-color)';
      button.style.border = '2px solid var(--primary-color)';
      button.style.color = 'var(--primary-color)';
    });
  };
  const servicesList = [
    
    {
      id: 1,
      title: 'Nursing Attendant',
      description: 'Nursing attendant services for home nursing',
      image: '/images/nursing-attendant.jpg'
    },
    {
      id: 2,
      title: 'Nursing Care',
      description: 'Professional nursing care with experienced staff',
      image: '/images/nursing.jpg'
    },
    {
      id: 3,
      title: 'Care Giver',
      description: 'Specialized care services for elderly patients',
      image: '/images/care-giver.jpg'
    },
    // {
    //   id: 4,
    //   title: 'Medical Equipment',
    //   description: 'Rent or purchase medical equipment',
    //   image: '/images/doctor.png'
    // },
    
    {
      id: 4,
      title: 'Mother & Baby Care',
      description: 'Comprehensive care for new mothers and infants',
      image: '/images/baby-care.jpg'
    },
    {
      id: 5,
      title: 'Physiotherapy',
      description: 'Expert physiotherapy services at home for faster recovery',
      image: '/images/physiotherapy.jpg'
    },
     {
      id: 6,
      title: 'Doctor Consultation',
      description: 'Consult with qualified doctors from home',
      image: '/images/doctor-consult.jpg'
    },
    {
      id: 7,
      title: 'ICU At Home',
      description: 'Specialized care for serious medical conditions',
      image: '/images/icu.jpg'
    },
    {
      id: 8,
      title: 'IV & IM Injection',
      description: 'IV & IM Injection services at home',
      image: '/images/iv-injection.jpg'
    },
    {
      id: 9,
      title: 'Lab Tests',
      description: 'Convenient diagnostic tests in the comfort of your home',
      image: '/images/lab.jpg'
    },
    {
      id: 10,
      title: 'Parkinson Care',
      description: 'Specialized care for Parkinson patients',
      image: '/images/parkison-care.jpg'
    },
  ];

  return (
    <div className="services-section" id="services">
      <Container className='services-container'>
        <div className="section-header text-center">
          <h2>Our Services</h2>
          <p>Quality healthcare services delivered at your doorstep</p>
        </div>
        <Row className='services-row'>
          {servicesList.map((service) => (
            <Col lg={3} md={6} sm={12} key={service.id} className="mb-4 service-col">
              <Card className="service-card h-100">
                <Card.Body className="text-center d-flex flex-column align-items-center service-body">
                  <div className="service-icon">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <Card.Title className="service-title">{service.title}</Card.Title>
                  <Card.Text className="service-description">{service.description}</Card.Text>
                  <Button onClick={() => { handleBookNow(service.title) }} className="service-book-btn">Book Now</Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {/* <div className="text-center mt-5">
          <Button className="btn-outline-primary view-all-btn">View All Services</Button>
        </div> */}
        <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService={serviceName}
      />
      </Container>
    </div>
  );
};

export default Services;
